"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prefer-promise-reject-errors */
const react_1 = __importStar(require("react"));
const form_1 = __importDefault(require("antd/lib/form"));
const input_1 = __importDefault(require("antd/lib/input"));
const recoil_1 = require("recoil");
const lodash_1 = __importDefault(require("lodash"));
const react_i18next_1 = require("react-i18next");
const FoldersTree_1 = __importStar(require("../FoldersPage/FoldersTree"));
const CustomModal_1 = __importDefault(require("./CustomModal"));
const core_1 = require("@material-ui/core");
const components_1 = require("@alcumus/components");
const Toast_1 = require("../Toast/Toast");
const useStyles = (0, core_1.makeStyles)(() => ({
    dashboardText: {
        fontWeight: components_1.StyleVariables.fonts.weight.regular,
    },
    dashboardInput: {
        borderRadius: '8px',
        borderLeft: `4px solid ${components_1.StyleVariables.colors.border.critical}`,
        height: 40,
    },
    folderText: {
        display: 'flex',
        marginBottom: 5,
    },
    iconColor: {
        color: `${components_1.StyleVariables.colors.text.success}`,
    },
    mandatoryText: {
        color: components_1.StyleVariables.colors.text.critical,
        fontSize: `${components_1.StyleVariables.fonts.size.small} !important`,
        marginLeft: 2,
    },
}));
const SaveInFolderModal = ({ id, formSubmitCallback, successCallback, successMessage, failureMessage, errorMessage, titleName, titleValidationCallback, currentFolderName, placeholder, duplicateErrorMessage, hideFolderTree, autoFocus, headerText, primaryButtonText, visible, setVisible, t, singleSelect, resetModalCallback, }) => {
    const [isFormSubmitting, setIsFormSubmitting] = (0, react_1.useState)(false);
    const [selectedFolderNode, setSelectedFolder] = (0, recoil_1.useRecoilState)(FoldersTree_1.selectedFolderState);
    const [title, setTitle] = (0, react_1.useState)();
    const isMounted = (0, react_1.useRef)(true);
    const [form] = form_1.default.useForm();
    const classes = useStyles();
    const [toastProps, setToastProps] = (0, recoil_1.useRecoilState)(Toast_1.showToastState);
    const validateTitleUniqueness = async (title, folderId) => {
        if (folderId !== undefined) {
            const isTitleUnique = await titleValidationCallback(title, folderId);
            if (!isTitleUnique) {
                setIsFormSubmitting(false);
                return Promise.reject(duplicateErrorMessage);
            }
            return Promise.resolve();
        }
    };
    const handleFormSubmit = async () => {
        setIsFormSubmitting(true);
        const values = await form
            .validateFields()
            .catch((errors) => console.log('errors', errors));
        if (!values) {
            setIsFormSubmitting(false);
            return;
        }
        validateTitleUniqueness(values[titleName], selectedFolderNode?.value)
            .then(() => {
            const _title = values[titleName];
            const selectedFolder = selectedFolderNode?.value;
            formSubmitCallback(_title, selectedFolder)
                .then((result) => {
                resetModal();
                if (successCallback && lodash_1.default.isFunction(successCallback))
                    successCallback(result);
                return result
                    ? setToastProps({
                        ...toastProps,
                        showToast: true,
                        severity: 'success',
                        message: successMessage,
                    })
                    : setToastProps({
                        ...toastProps,
                        showToast: true,
                        severity: 'error',
                        message: failureMessage,
                    });
            })
                .catch(() => {
                setToastProps({
                    ...toastProps,
                    showToast: true,
                    severity: 'error',
                    message: errorMessage,
                });
            })
                .finally(() => {
                if (isMounted.current)
                    setIsFormSubmitting(false);
            });
        })
            .catch(() => {
            setToastProps({
                ...toastProps,
                showToast: true,
                severity: 'error',
                message: duplicateErrorMessage,
            });
        });
    };
    function resetModal() {
        if (isFormSubmitting)
            return;
        if (resetModalCallback)
            resetModalCallback();
        form.resetFields();
        setSelectedFolder(undefined);
        setTitle(undefined);
        setVisible(false);
    }
    const formProps = {
        name: `${titleName}-form`,
        layout: 'vertical',
        form,
        requiredMark: true,
        onFinish: handleFormSubmit,
    };
    (0, react_1.useEffect)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    });
    return (react_1.default.createElement(CustomModal_1.default, { open: visible, "data-testid": id, headerText: headerText, primaryButtonText: primaryButtonText, disablePrimaryButton: !title || isFormSubmitting, onHide: resetModal, isValidating: isFormSubmitting, onPrimaryAction: async () => await handleFormSubmit(), modalBody: react_1.default.createElement(react_1.default.Fragment, null,
            singleSelect,
            react_1.default.createElement(form_1.default, { ...formProps },
                react_1.default.createElement(form_1.default.Item, { label: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: classes.dashboardText }, t('title')),
                        react_1.default.createElement("label", { className: classes.mandatoryText }, '*')), initialValue: currentFolderName, name: titleName, rules: [
                        {
                            required: true,
                            type: 'string',
                            validator: async (rule, value) => {
                                setTitle(value);
                                if (!value)
                                    return Promise.reject(t('dashboardTitleRequired'));
                                return await validateTitleUniqueness(value, selectedFolderNode?.value);
                            },
                        },
                    ] },
                    react_1.default.createElement(input_1.default, { "data-testid": "inputTitleBox", placeholder: placeholder, autoFocus: autoFocus, className: classes.dashboardInput }))),
            !hideFolderTree && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: classes.folderText },
                    react_1.default.createElement(components_1.Text, { as: "span" }, t('saveTo')),
                    react_1.default.createElement("label", { className: classes.mandatoryText }, '*')),
                react_1.default.createElement(FoldersTree_1.default, { visible: visible })))) }));
};
exports.default = (0, react_i18next_1.withTranslation)('ModalWindow')(SaveInFolderModal);
